import React from "react";
import { Redirect } from "react-router-dom";

export default function LoadGameScreen() {
  return <Redirect to="/game" />;
}
